// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"f0376340","977":"4a2018a5"}[chunkId] + ".chunk.js";
};